import React, {useState, useRef, useEffect} from 'react';
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';
import './UserEditMain.css';
import { USER_ROLE_SET } from '../../../../config/UserRoleSet';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )})

const UserEditMain = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return ()=>clearInterval(timerId);
  }, [tooltipShow])

  return (
    <div className="row featured-main">
      <div className="UserEditTitle">
        <sapn className="purple">프로필 편집</sapn>
      </div>
      <div className="UserEditContainer">
        <table className="UserEditTable" width="100%">
          <tr>
            <td align="right" style={{width: "120px"}}>
              <span className="UserEditTit">Email</span>
            </td>
            <td>
              {props.email}
            </td>
          </tr>
          <tr>
            <td align="right" tyle={{width: "120px"}}>
              <span className="UserEditTit">이름</span>
            </td>
            <td>
              <InputText onChange={props.handleUsername} value={props.username} name="name-textfield" type="text" className="box" id="textfield1" size="25" />
            </td>
          </tr>
          <tr>
            <td align="right" style={{width: "120px"}}>
              <span className="UserEditTit">현재 패스워드</span>
            </td>
            <td>
              <InputText onChange={props.handlePassword} value={props.password} name="passwordfield" type="password" className="box" id="textfield2" size="25" />
            </td>
          </tr>
          <tr>
            <td align="right" style={{width: "120px"}}>
              <span className="UserEditTit">새 패스워드</span>
            </td>
            <td>
              <InputText onChange={props.handleNewPassword} value={props.newPassword} name="newpasswordfield" type="password" className="box" id="textfield3" size="25" />
              <span className="condition-tooltip">8자 이상을 입력해주세요.</span>
            </td>
          </tr>
          <tr>
            <td align="right" style={{width: "120px"}}>
              <span className="UserEditTit">패스워드 확인</span>
            </td>
            <td>
              <InputText onChange={props.handleConfirmPassword} value={props.confirmPassword} name="confirmpasswordfield" type="password" className="box" id="textfield4" size="25" />
              {props.newPassword==props.confirmPassword ? <></>:<span className="validation-tooltip">일치하지 않습니다.</span>}
            </td>
          </tr>
          <tr>
            <td align="right" style={{width: "120px"}}>
              <span className="UserEditTit">권한</span>
            </td>
            <td>
              {
                props.role != '' && USER_ROLE_SET.find(item=>item.role==props.role).name
              }
            </td>
          </tr>
        </table>
        <div className="user-edit-save-box">
          {/* <a className="button darkGray" style={{marginTop: "0px"}} ref={tooltipTarget} onClick={()=>{props.handleSave(); setTooltipShow(true)}}>Save</a> */}
          <a className="button purple_line" ref={tooltipTarget} onClick={()=>{props.handleSave(); setTooltipShow(true)}}>저장</a>
          <TooltipWithTimer target={tooltipTarget} show={tooltipShow} tooltipDirection="top" tooltipText={props.saveTooltip} />
        </div>
      </div>
    </div>
  )
}

export default UserEditMain;